module.exports = __webpack_public_path__ + "img/code-square.e8638cde.svg";